import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ExampleResponseModel } from "../../models/example/example-stuff.model";

@Injectable({
  providedIn: 'root'
})
export class ExampleService {

  private GET_EXAMPLE_STUFF_URL = 'api/example/stuff';

  constructor(
    private _httpClient: HttpClient
  ) {
  }

  get getStuff$(): Observable<ExampleResponseModel[]> {
    return this._httpClient.get<ExampleResponseModel[]>(this.GET_EXAMPLE_STUFF_URL);
  }
}
